<template>
  <div>
    <ProviderMapHeaderEmbed class="opacity-map" :scale-to="55" :center-to="[10,10]" :countries="countries_id" />
    <ProviderProfileCard :provider="provider" :list-countries="countries_id"/>
    <div>
      <AppFooterEmbed>
      </AppFooterEmbed>
    </div>
  </div>
  
</template>

<style>
  .opacity-map {
    position: absolute;
    top: 0;
    width: 100%;
    left: 0;
    opacity: 0.5;
  }
</style>

<script>
  import AppFooterEmbed from '@/components/AppFooterEmbed.vue'
  import ProviderMapHeaderEmbed from '@/components/ProviderMapHeaderEmbed.vue'
  import ProviderProfileCard from '@/components/ProviderProfileCard'
  import provider from '@/mixins/provider'

  export default {
    name: 'ProviderProfileEmbed',
    components: {
      AppFooterEmbed,
      ProviderProfileCard,
      ProviderMapHeaderEmbed
    },
    mixins: [provider],
    mounted() {
      this.findProvider(this.$route.params.provider_id)
    }
  }
</script>
